export const approveTopup = {
  approveTopup: "Approve Topup V1",
  from: "From",
  to: "To",
  notification: "Notification",
  payment: "Payment",
  txnRemark: "TXN REMARK",
  accountId: "ACCOUNT ID",
  remark: "Remark",
  depositDate: "DEPOSIT DATE",
  withdrawDate: "WITHDRAW DATE",
  bank: "BANK",
  date: "Date",
  manualdeposit: "Manual Deposit",
  accountName: "ACCOUNT NAME",
  amount: "AMOUNT",
  requestedDate: "REQUESTED DATE",
  rejectTopup: "Reject Topup",
};
